import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { SidesheetOpenOptions } from '../../models';
import { SidesheetComponentOptions } from '../../shared/enums';

@Injectable({
    providedIn: 'root'
})
export class SidesheetUtilityService {

    private _isOpened = new Subject<boolean>();
    private _isClosed = new Subject<boolean>();
    private _queuedSidesheet: { component: SidesheetComponentOptions; options: SidesheetOpenOptions } | null = null;
    isOpened$ = this._isOpened.asObservable();
    isClosed$ = this._isClosed.asObservable();

    isDisplayed = false;
    currentSidesheetComponent = SidesheetComponentOptions.None;
    isExternalCloseDisabled = false;
    initialTabIndex = 0;

    get hasQueuedSidesheet(): boolean {
        return this._queuedSidesheet !== null;
    }

    constructor() { }

    closeSidesheet(): void {
        this._isOpened.next(false);
    }

    openSidesheet(sidesheetComponent: SidesheetComponentOptions, options: SidesheetOpenOptions = {}): void {
        document.body.style.overflow = 'hidden';
        this.isDisplayed = true;
        this.currentSidesheetComponent = sidesheetComponent;
        this.isExternalCloseDisabled = options.disableExternalClose ?? false;
        this.initialTabIndex = options.initialTabIndex ?? 0;
        this._isOpened.next(true);
    }

    clearCurrentSidesheetComponent(): void {
        this.currentSidesheetComponent = SidesheetComponentOptions.None;
        this.isExternalCloseDisabled = false;
        this.initialTabIndex = 0;
    }

    setIsDisplayed(isDisplayed: boolean): void {
        this.isDisplayed = isDisplayed;
        if (!isDisplayed) {
            document.body.style.overflow = '';
            this._isClosed.next(true);
        }
    }

    // Opens once the destination layout's sidesheet host is ready (used by route guards).
    queueSidesheet(sidesheetComponent: SidesheetComponentOptions, options: SidesheetOpenOptions = {}): void {
        this._queuedSidesheet = { component: sidesheetComponent, options: options };
    }

    openQueuedSidesheet(): void {
        if (this._queuedSidesheet === null) {
            return;
        }

        const { component, options } = this._queuedSidesheet;
        this._queuedSidesheet = null;
        this.openSidesheet(component, options);
    }

}
